import type {
  CountableApiResponse,
  SerializedMeter,
  SerializedRevision,
  UpdateRevisionDto,
} from '@enmon/commons/lib/enmon';
import { BaseApiClient } from '../baseApiClient';

export interface RevisionsFilter {
  meterId: SerializedMeter['_id'];
}

export type GetRevisionsArgs = RevisionsFilter;
export type GetRevisionsResponse = CountableApiResponse<SerializedRevision[]>;

export interface UpdateRevisionArg {
  meterId: SerializedMeter['_id'];
  revisionId: SerializedRevision['_id'];
  payload: UpdateRevisionDto;
}
export type UpdateRevisionResponse = SerializedRevision;

export interface DeleteRevisionArg {
  meterId: SerializedMeter['_id'];
  revisionId: SerializedRevision['_id'];
}
export type DeleteRevisionResponse = void;

export interface RevertRevisionArg {
  meterId: SerializedMeter['_id'];
}
export type RevertRevisionResponse = void;

export class BackendGatewayRevisionsApiClient extends BaseApiClient {
  constructor(jwt: string) {
    super('enmon-tools/meters', undefined, jwt);
  }

  public async find({ meterId }: GetRevisionsArgs): Promise<GetRevisionsResponse> {
    const response = await this.axios.get<GetRevisionsResponse>(`${meterId}/revisions`);
    return response.data;
  }

  public async update({ meterId, revisionId, payload }: UpdateRevisionArg): Promise<UpdateRevisionResponse> {
    const response = await this.axios.patch<UpdateRevisionResponse>(`${meterId}/revisions/${revisionId}`, payload);
    return response.data;
  }

  public async delete({ meterId, revisionId }: DeleteRevisionArg): Promise<DeleteRevisionResponse> {
    await this.axios.delete<DeleteRevisionResponse>(`${meterId}/revisions/${revisionId}`);
  }

  public async revert({ meterId }: RevertRevisionArg): Promise<RevertRevisionResponse> {
    await this.axios.put<RevertRevisionResponse>(`${meterId}/revisions/revert`);
  }
}
